import React, { useState } from "react";
import {
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import backImg from "../../common/assests/backImg.png";
import { toast } from "react-toastify";
import CustomBtn from "../../common/customButton/CustomBtn";
import { handleChangePassApi } from "../../api";
import { useConfirm } from "../../common/confirmDialog/useConfirm";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    background: "#fff",
    fontFamily: "Heebo",
    "& fieldset": { borderColor: "#E7E7E7" },
    "&:hover fieldset": { borderColor: "#D7D7D7" },
    "&.Mui-focused fieldset": { borderColor: "#065F46" },
  },
};

const ConfirmPassModal = ({ onSubmit, onBack, refId }) => {
  const confirm = useConfirm();
  const [btnDisable, setBtnDisable] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleToggleNewPassword = () => setShowNewPassword((prev) => !prev);
  const handleToggleConfirmPassword = () => setShowConfirmPassword((prev) => !prev);

  const handleSubmitNewPassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.warning("All fields are required");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.warning("Passwords did not match");
      return;
    }
    if (newPassword.length < 8) {
      toast.warning("Password should be at least 8 characters long");
      return;
    }
    const isConfirmed = await confirm({
      title: "Change Password",
      description: "Are you sure you want to change your password?",
      confirmText: "Change",
    });
    if (!isConfirmed) return;
    try {
      setLoading(true);
      setBtnDisable(true);
      const response = await handleChangePassApi({ refId, newPassword });
      toast.success(response.message);
      setNewPassword("");
      setConfirmPassword("");
      onSubmit();
      setLoading(false);
    } catch (error) {
      setBtnDisable(false);
      setLoading(false);
      toast.error(error.message);
      console.log("error", error);
    }
  };

  const EyeAdornment = ({ show, onToggle }) => (
    <InputAdornment position="end">
      <IconButton size="small" onClick={onToggle} edge="end">
        {show
          ? <VisibilityOutlinedIcon sx={{ fontSize: 18, color: "#8B8B8B" }} />
          : <VisibilityOffOutlinedIcon sx={{ fontSize: 18, color: "#8B8B8B" }} />}
      </IconButton>
    </InputAdornment>
  );

  return (
    <DialogContent sx={{ padding: "10px" }}>
      <Box sx={{ marginTop: '20px', paddingLeft: '20px' }}>
        <Typography
          sx={{ display: "flex", flexDirection: "row", width: "20%", alignItems: "center", cursor: "pointer", gap: '10px' }}
          onClick={onBack}
        >
          <img src={backImg} alt="backImg" style={{ height: "29px", width: "29px" }} />
          <Typography sx={{ color: "#065F46", fontWeight: "500", fontSize: "20px" }}>Back</Typography>
        </Typography>
      </Box>

      <DialogTitle sx={{ textAlign: "left", fontSize: "24px", fontWeight: "700", fontFamily: "Heebo", marginTop: '20px', paddingLeft: '30px' }}>
        Set New Password
      </DialogTitle>
      <DialogTitle sx={{ marginTop: "-27px", fontSize: "14px", fontWeight: "400", fontFamily: "Heebo", opacity: "0.5", paddingLeft: '30px' }}>
        Set your password here whatever you wanted
      </DialogTitle>

      <Box sx={{ width: "90%", margin: "0 auto" }}>
        <Typography sx={{ mb: "8px", mt: '20px', textAlign: "left", ml: "4px", fontSize: "14px", fontWeight: "600", fontFamily: "Heebo", color: "#362B24" }}>
          New Password
        </Typography>
        <TextField
          fullWidth
          size="small"
          type={showNewPassword ? "text" : "password"}
          placeholder="Type your new password"
          value={newPassword}
          onChange={(e) => { if (e.target.value.trim() !== "" || e.target.value === "") setNewPassword(e.target.value); }}
          sx={{ ...inputSx, mb: 2 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon sx={{ color: "#8B8B8B", fontSize: 18 }} />
              </InputAdornment>
            ),
            endAdornment: <EyeAdornment show={showNewPassword} onToggle={handleToggleNewPassword} />,
          }}
        />
      </Box>

      <Box sx={{ width: "90%", margin: "0 auto" }}>
        <Typography sx={{ mb: "8px", textAlign: "left", ml: "4px", fontSize: "14px", fontWeight: "600", fontFamily: "Heebo", color: "#362B24" }}>
          Retype Password
        </Typography>
        <TextField
          fullWidth
          size="small"
          type={showConfirmPassword ? "text" : "password"}
          placeholder="Retype your password"
          value={confirmPassword}
          onChange={(e) => { if (e.target.value.trim() !== "" || e.target.value === "") setConfirmPassword(e.target.value); }}
          sx={{ ...inputSx, mb: 2.5 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon sx={{ color: "#8B8B8B", fontSize: 18 }} />
              </InputAdornment>
            ),
            endAdornment: <EyeAdornment show={showConfirmPassword} onToggle={handleToggleConfirmPassword} />,
          }}
        />
      </Box>

      <Box sx={{ width: "90%", margin: "0 auto", display: "flex", justifyContent: "center", mt: 1, mb: '20px' }}>
        <CustomBtn onClick={handleSubmitNewPassword} text="Submit" disable={btnDisable} loading={loading} />
      </Box>
    </DialogContent>
  );
};

export default ConfirmPassModal;
